const initInstallmentBankButtons = () => {
  const installmentButtons = document.querySelectorAll('button.installments-item-container');
  const installmentButtonHandler = event => {
    const button = event.target.closest('.installments-item-container');
    const selectedIndex = button.getAttribute('data-set-index');
    const installmentInfoElements = document.querySelectorAll('div.installments-info');
    installmentInfoElements.forEach(el => {
      if(el.getAttribute('data-set-index') === selectedIndex) {
        el.classList.add('active');
        return;
      }
      el.classList.remove('active');
    });
    installmentButtons.forEach(el => {
      if(el.getAttribute('data-set-index') === selectedIndex) {
        el.classList.add('active');
        return;
      }
      el.classList.remove('active');
    });
  };
  installmentButtons.forEach(btn => btn.addEventListener('click', installmentButtonHandler));

  // horizontal scroll
  const installmentTabBar = document.querySelector('.installments-row__tab-heading');
  const isScrollable = installmentTabBar.scrollWidth > installmentTabBar.clientWidth;
  if (isScrollable) {
    initHorizontalScroll(installmentTabBar, { hideScrollBar: true, desktopSwipe: true });
  }
}
initInstallmentBankButtons();